import { z } from 'zod';

const envSchema = z
  .object({
    BASE_URL: z.string().url(),
    API_BASE_URL: z.string().url(),
    COGNITO_REGION: z.string(),
    COGNITO_USER_POOL_ID: z.string(),
    COGNITO_CLIENT_ID: z.string(),
    COGNITO_REDIRECT_URI: z.string().url(),
    COGNITO_DOMAIN: z.string(),
    PROXY_DELAY: z.number().default(800),
    SECRET_KEY: z.string(),

    BASIC_AUTH_ENABLED: z.preprocess(
      (v) => v === 'true',
      z.boolean().default(false),
    ),
    BASIC_AUTH_USERNAME: z.string().optional(),
    BASIC_AUTH_PASSWORD: z.string().optional(),
    DISABLE_TRPC_RETRY: z.preprocess(
      (v) => v === 'true',
      z.boolean().default(false),
    ),
    DISABLE_PROXY_TRPC: z.preprocess(
      (v) => v === 'true',
      z.boolean().default(false),
    ),

    // システムアドミンの組織一覧に出す「TRUNKの管理画面へ」ボタンの切り替え先。
    // 組織IDは環境ごとに違うため Terraform から渡す。未設定の環境ではボタンを出さない。
    // 空文字は未設定として扱う。このキーは未設定が正常系なので、機能を止めたい人が
    // 値を空にしたときに検証で落として配信を止めるのは釣り合わない
    TRUNK_ORGANIZATION_ID: z.preprocess(
      (v) => (v === '' ? undefined : v),
      z.string().uuid().optional(),
    ),

    // ヘルプ（help.asobi.work-school.com）の受け口。/help-auth が、発行したトークンを付けてここへ移す（app/help-auth）。
    // 本番だけに置く。未設定の環境では /help-auth を 404 にする。空文字は未設定として扱う
    HELP_AUTH_CALLBACK_URL: z.preprocess(
      (v) => (v === '' ? undefined : v),
      z
        .string()
        .url()
        .refine((v) => v.startsWith('https://'), 'https の URL にする')
        .optional(),
    ),

    // Firebase の設定, 通知に利用
    FIREBASE_CONFIG: z.string().min(1),
    FIREBASE_VAPID_PUBLIC_KEY: z.string().min(1),
  })
  .refine(
    (data) => {
      if (data.BASIC_AUTH_ENABLED) {
        return data.BASIC_AUTH_USERNAME && data.BASIC_AUTH_PASSWORD;
      }
      return true;
    },
    {
      message:
        'BASIC_AUTH_ENABLED が true の場合、BASIC_AUTH_USERNAME と BASIC_AUTH_PASSWORD は必須です。',
      path: ['BASIC_AUTH_USERNAME', 'BASIC_AUTH_PASSWORD'],
    },
  );

export const env = parseEnv();

function parseEnv() {
  // ビルド時はチェックしない
  if (process.env.NEXT_BUILD === 'yes') {
    return {} as z.infer<typeof envSchema>;
  }

  // ブラウザでは使わないのでチェックしない
  if (typeof window !== 'undefined') {
    return {} as z.infer<typeof envSchema>;
  }

  const proxyDelay = Number(process.env.PROXY_DELAY);

  const parsed = envSchema.parse({
    ...process.env,
    PROXY_DELAY: Number.isNaN(proxyDelay) ? undefined : proxyDelay,
  });

  return parsed;
}
